"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RequiredField = void 0;
var _react = _interopRequireDefault(require("react"));
var _elements = require("../elements");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var RequiredField = function RequiredField(props) {
  return /*#__PURE__*/_react.default.createElement(_elements.Text, _extends({
    variant: "xs",
    color: props.disabled ? "black30" : "black60",
    textAlign: "left"
  }, props), "*Required");
};
exports.RequiredField = RequiredField;
RequiredField.displayName = "RequiredField";
//# sourceMappingURL=RequiredField.js.map